import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/index";
import InventoryPage from "./pages/inventoryPage";
import LogsPage from "./pages/logsPage";
import OnHoldInventoryView from "./pages/onHoldView";
import StoreLayoutPage from "./pages/storeLayoutPage";
import CasesPage from "./pages/casesPage";
import FrontInventoryView from "./components/frontInventoryView";
import { auth } from "./firebaseConfig";
import { useAuthState } from "react-firebase-hooks/auth";
import Navbar from "./components/navbar";
import MainPageSpinner from "./components/mainPageSpinner";
import Cartier from "./pages/cartierCounterPage";

const App = () => {
  const [user, loading] = useAuthState(auth);

  if (loading) return <MainPageSpinner />;

  return (
    <Router>
      {user && <Navbar user={user} />}
      <Routes>
        <Route path="/" element={user ? <Navigate to="/inventory" /> : <LoginPage />} />
        <Route path="/inventory" element={user ? <InventoryPage user={user} /> : <Navigate to="/" />} />
        <Route path="/inventory/onhold" element={user ? <OnHoldInventoryView user={user} /> : <Navigate to="/" />} />
        <Route path="/logs" element={user ? <LogsPage user={user} /> : <Navigate to="/" />} />
        <Route path="/cases" element={user ? <CasesPage /> : <Navigate to="/" />} />
        <Route path="/inventory/front" element={user ? <FrontInventoryView user={user} /> : <Navigate to="/" />} />
        <Route
          path="/cartier"
          element={user ? <Cartier /> : <Navigate to="/" />}
        />
      </Routes>
    </Router>
  );
};

export default App;
